import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from '@playbookux/playbook-web-core';
import CalendarTimePicker from '../calendar-time-picker';

import TimeZoneDropdown from '../../../../core/components/timezone-dropdown';

import {
  Card,
  Title,
  ContainerDropDown,
  ContainerTimerSchedule,
  Container,
} from './styles';

const DEFAULT_TIMEZONE = 'US/Eastern';

const CardSchedule = (props) => {
  const {
    onChangeTimezone,
    onTimeChange,
    timeZone,
    selectedTime,
    timeSlots,
    onInitialDateChange,
    onSetTimezoneName,
    initialDate,
    loading,
    history,
    dataAudience,
    toggleTime,
    setToggleTime,
    phrases,
  } = props;

  return (
    <Container role="main">
      <Card>
        <Title as="h1">{phrases.select_time_header}</Title>

        <ContainerDropDown
          aria-label="timezone-dropdown"
        >
          <TimeZoneDropdown
            onChange={onChangeTimezone}
            timeZone={timeZone || DEFAULT_TIMEZONE}
            toggleTime={toggleTime}
            onChangeToggle={setToggleTime}
            tabIndex={0}
            onSetTimezoneName={onSetTimezoneName}
          />
        </ContainerDropDown>

        <ContainerTimerSchedule>
          <CalendarTimePicker
            onTimeChange={onTimeChange}
            selectedTime={selectedTime}
            timeSlots={timeSlots}
            timeZone={timeZone}
            onInitialDateChange={onInitialDateChange}
            initialDate={initialDate}
            loading={loading}
            toggleTime={toggleTime}
            history={history}
            dataAudience={dataAudience}
          />
        </ContainerTimerSchedule>
      </Card>

    </Container>
  );
};

CardSchedule.propTypes = {
  onChangeTimezone: PropTypes.func.isRequired,
  onTimeChange: PropTypes.func.isRequired,
  timeZone: PropTypes.string,
  selectedTime: PropTypes.string,
  timeSlots: PropTypes.oneOfType([PropTypes.array]).isRequired,
  onInitialDateChange: PropTypes.func.isRequired,
  initialDate: PropTypes.oneOfType([PropTypes.object]).isRequired,
  loading: PropTypes.bool.isRequired,
  dataAudience: PropTypes.shape(),
  onSetTimezoneName: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  toggleTime: PropTypes.bool.isRequired,
  setToggleTime: PropTypes.func.isRequired,
  phrases: PropTypes.shape({
    select_time_header: PropTypes.string,
  }).isRequired,
};

CardSchedule.defaultProps = {
  timeZone: null,
  selectedTime: null,
  dataAudience: {},
};

export default withTranslation(CardSchedule);
